import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "layout-sidebar" };
import AppSideSpeedDial from "@/components/templates/Layout/AppSideSpeedDial.vue";
import { ref } from "vue";
import { useRouter } from "vue-router";
export default /*#__PURE__*/ _defineComponent({
    __name: 'BackOfficeUsersView',
    setup(__props) {
        const router = useRouter();
        const items = ref([
            { label: 'Users', icon: 'pi pi-fw pi-user-edit', command: () => router.push({ name: 'AdminUsers' }) },
            { label: 'Authorizations', icon: 'pi pi-fw pi-unlock', command: () => router.push({ name: 'AdminAuthorizations' }) },
        ]);
        return (_ctx, _cache) => {
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(AppSideSpeedDial, { items: items.value }, null, 8, ["items"])
                ]),
                _createVNode(_component_router_view)
            ], 64));
        };
    }
});
